import React from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./components/Home";
import Login from "./components/Login";
import ParentSignup from "./components/Signup/ParentSignup";
import StudentSignup from "./components/Signup/StudentSignup";
import SignUp from "./components/SignUp";
import AboutUs from "./components/AboutUs";
import ParentInfo from "./components/InfoPages/ParentInfo";
import StudentInfo from "./components/InfoPages/StudentInfo";
import CommonQA from "./components/CommonQA";
import MapsPage from "./components/MapsPage";
import Terms from "./components/Terms/Info";
import TempJob from "./components/TempPosition/TempJob";
import UserHome from "./components/UserHome";
import Logout from "./components/Menu/Logout";
import Confirm from "./components/Terms/Confirm";
import LandingPage from "./components/Landing/LandingPage";

function App(props) {
  const { isAuthenticated, isVerifying } = props;
  return (
    <Switch>
      <ProtectedRoute
        exact
        path="/"
        component={Home}
        isAuthenticated={isAuthenticated}
        isVerifying={isVerifying}
      />
      <Route path="/confirm" component={Confirm} />
      <Route path="/home" component={Home} />
      <Route path="/login" component={Login} />
      <Route path="/signup" component={SignUp} />
      <Route
        path="/parentsignup"
        render={(props) => <ParentSignup {...props} />}
      />
      <Route path="/studentsignup" component={StudentSignup} />
      <Route path="/aboutus" component={AboutUs} />
      <Route path="/parentinfo" component={ParentInfo} />
      <Route path="/studentinfo" component={StudentInfo} />
      <Route path="/mapspage" component={MapsPage} />
      <Route path="/commonQA" component={CommonQA} />
      <Route path="/terms" component={Terms} />
      <Route path="/tempjob" component={TempJob} />
      <Route path="/userhome" component={UserHome} />
      <Route path="/logout" component={Logout} />
      <Route path="/landingpage" component={LandingPage} />
    </Switch>
  );
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    isVerifying: state.auth.isVerifying,
  };
}

export default connect(mapStateToProps)(App);
